export default __webpack_public_path__ + "f84b476995a8496adce24ec672244eafc9a43686/c58a79ed7dc2ca14963e3366521c8d07.png";